import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const compact = (n) => (n >= 1e6 ? `${(n / 1e6).toFixed(n % 1e6 === 0 ? 0 : 1)}M` : n >= 1e3 ? `${Math.round(n / 1e3)}k` : String(Math.round(n)));

export function formatCount(n, c) {
  const body = c.compact ? compact(n) : c.decimals != null ? n.toFixed(c.decimals) : Math.round(n).toLocaleString("en-US");
  return `${c.prefix || ""}${body}${c.suffix || ""}`;
}

export function CountUp({ counter, duration = 3000, className = "", testId }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(counter.from);
  useEffect(() => {
    if (!inView) return;
    let raf;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(counter.from + (counter.to - counter.from) * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, counter, duration]);
  return <span ref={ref} data-testid={testId} className={`tabular-nums ${className}`}>{formatCount(n, counter)}</span>;
}
